/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OrderViewModel } from './OrderViewModel'; 

export function getOrdersByCertificationPeriodOptions(certificationPeriodId: string, onSuccess?: (result: OrderViewModel[]) => void) {
	return queryOptions({
		queryKey: ['orders-by-certification-period', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/orders/queries/getordersbycertificationperiod/' + certificationPeriodId;
			const resp = await axios.get<OrderViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}